import { inject } from '@angular/core';
import { MsalBroadcastService } from '@azure/msal-angular';
import { InteractionStatus } from '@azure/msal-browser';
import { filter, firstValueFrom, of, switchMap, take } from 'rxjs';
import { UserSyncService } from '@app/core/services/user-sync.service';
import { AuthService } from '@app/core/services/auth.service';

export function syncInitializerFactory() {
  const authService = inject(AuthService);
  const broadcastService = inject(MsalBroadcastService);
  const userSyncService = inject(UserSyncService);

  return firstValueFrom(
    broadcastService.inProgress$.pipe(
      filter((status) => status === InteractionStatus.None),
      take(1),
      switchMap(() => {
        if (authService.isAuthenticated()) {
          return userSyncService.sync();
        }
        return of(undefined);
      }),
    ),
  );
}
